// extracted by mini-css-extract-plugin
export var cover = "PageDataBodyVideo-module--cover--3oB4C";
export var hide = "PageDataBodyVideo-module--hide--cjEK9";
export var play = "PageDataBodyVideo-module--play--VXha8";
export var title = "PageDataBodyVideo-module--title--3GxtC";
export var video = "PageDataBodyVideo-module--video--TsWRB";
export var videoSlice = "PageDataBodyVideo-module--videoSlice--7Fi90";